import React, { useMemo } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import { useTranslation } from 'react-i18next';
import { useUserStatus } from 'infrastructure/hooks/use-user-status';

import type { IBaseSelectBoxProps } from 'components/atoms/base-select-box/types';

const UserStatusSelectBox: React.FC<IBaseSelectBoxProps> = (props) => {
  const { t } = useTranslation();

  const { loading, statuses, currentStatus, setStatus } = useUserStatus();

  const inChartStatus = useMemo(() => {
    return statuses.find((el) => el.label.trim().toLowerCase() === 'in chart');
  }, [statuses]);

  const isInChartStatus = currentStatus === inChartStatus?.value;

  const filteredStatuses = useMemo(() => {
    if (isInChartStatus) return statuses;

    return statuses.filter(
      (el) => el.label.trim().toLowerCase() !== 'in chart',
    );
  }, [statuses, isInChartStatus]);

  return (
    <BaseSelectBox
      value={currentStatus}
      options={filteredStatuses}
      onChange={(_, rec) => setStatus(rec.record)}
      loading={loading}
      disabled={loading || isInChartStatus}
      placeholder={t('labels.yourStatus')}
      {...props}
    />
  );
};

export default UserStatusSelectBox;
